<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { FileText, Plus } from 'lucide-vue-next'

const emit = defineEmits<{
  'create-template': []
}>()

const { t } = useI18n()
</script>

<template>
  <div class="h-full bg-white flex flex-col items-center justify-center p-8">
    <FileText :size="96" class="text-gray-400 mb-6" />
    <h2 class="text-2xl font-semibold text-gray-800 mb-3">{{ t('noTemplatesYet') }}</h2>
    <p class="text-gray-600 mb-6 text-center max-w-md">
      {{ t('createFirstTemplate') }}
    </p>
    <button
      @click="emit('create-template')"
      class="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center gap-2"
    >
      <Plus :size="20" />
      {{ t('createLayout') }}
    </button>
  </div>
</template>
